import { cn } from "@/utils/cn";

export const getToolbarStyles = () => {
  return cn(
    "fixed z-50 top-0 flex w-full items-center justify-between bg-dark px-8 h-[60px] pt-6 pb-2 box-shadow"
  );
};

export const getToolbarRightSlotStyles = () => {
  return cn("flex flex-1 items-center gap-4");
};
